import { SyncedVideoGrid, Tooltip, type SyncedVideoTimelineApi } from "@carbon6/c6-frontend-design";
import type { InspectChannel, InspectVideo } from "../../domain/episodeInspect";
import { describeCue, videoCueAt } from "../../feature/videoTimeMapping";
import styles from "./CameraGrid.module.css";

type CameraGridProps = {
  videos: readonly InspectVideo[];
  channels: ReadonlyMap<string, InspectChannel>;
  transport: SyncedVideoTimelineApi;
  currentSeconds: number;
  onMediaError: (video: InspectVideo) => void;
  layout?: "grid" | "strip";
  active?: boolean;
};

/** 표시할 영상만 공통 엔진에 등록한다. blank·buffer·미디어 자원 수명은 c6가 소유한다. */
export function CameraGrid({
  active = true,
  channels,
  currentSeconds,
  layout = "grid",
  onMediaError,
  transport,
  videos,
}: CameraGridProps) {
  if (videos.length === 0)
    return <p className={styles.empty}>이 episode 에는 카메라 영상이 없습니다.</p>;
  return (
    <div
      className={styles.grid}
      data-layout={layout}
      data-count={videos.length}
      role="list"
      aria-label="카메라 영상"
    >
      {videos.map((video) => {
        const notice = describeCue(videoCueAt(video, channels.get(video.key), currentSeconds));
        return (
          <Tooltip key={video.key} content={video.key} describeTrigger>
            <div role="listitem" className={styles.tile}>
              {active ? (
                <SyncedVideoGrid
                  channels={[
                    {
                      id: video.key,
                      src: video.url,
                      label: video.key,
                      aspectRatio: video.height > 0 ? video.width / video.height : undefined,
                    },
                  ]}
                  timeline={transport}
                  frameAlign="center"
                  showLabels={false}
                  aspectRatioMode="channel"
                  maxHeight="100cqh"
                  onChannelError={() => onMediaError(video)}
                />
              ) : null}
              {notice === null ? null : <p className={styles.notice}>{notice}</p>}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}
